/**
 * Validates a National Provider Identifier (NPI)
 * @param {string|number} inputValue - The NPI to validate
 * @returns {{status: string, message: string}} Validation result with status ('SUCCESS'/'FAIL') and error message
 */
export const validateNPI = (inputValue) => {
    let npiValue = inputValue;
    let isValid = true;
    let errorMessage = "";

    /*  // Handle empty values
     if (!npiValue && npiValue !== 0) {
         return { status: 'FAIL', message: "NPI is required" };
     } */

    // Convert to string if it's a number
    npiValue = String(npiValue);

    if (npiValue.length > 0) {
        if (!isNaN(npiValue) && npiValue.length === 10) {
            npiValue = npiValue.split('');
            var checkBit = npiValue.pop(), npi_double = [], npi_unaffected = [];
            npiValue.reverse();
            for (var i = 0; i < npiValue.length; i++) {
                if ((i % 2) === 0) { npi_double.push((npiValue[i] * 2)); }
                if ((i % 2) === 1) { npi_unaffected.push(npiValue[i]); }
            }

            npi_double = npi_double.toString().replace(/,/g, '');
            npi_unaffected = npi_unaffected.toString().replace(/,/g, '');

            var total = npi_unaffected + npi_double, total_sum = 0;
            for (var index = 0; index < total.length; index++) {
                total_sum += parseInt(total.charAt(index));
            }
            total_sum += 24; //Magic Bit

            var final = Math.ceil((total_sum) / 10) * 10;

            if (parseInt(final - total_sum) !== parseInt(checkBit)) {
                isValid = false;
                errorMessage = "Failed NPI validation";
            }
        }
        else {
            isValid = false;
            errorMessage = "NPI must be 10  digits";
        }
    }

    return { status: isValid ? 'SUCCESS' : 'FAIL', message: errorMessage };
};

/**
 * Simplified NPI validation that returns a boolean
 * @param {string|number} npi - The NPI to validate
 * @returns {boolean} True if valid, false if invalid
 */
export const isValidNPI = (npi) => {
    return validateNPI(npi).status === 'SUCCESS';
};